<template>
<div class="header-nav" v-if="currentUser">
  <admin-nav v-if="admin"></admin-nav>
  <support-nav v-if="support"></support-nav>
  <current-user-nav v-if="currentUser.id"></current-user-nav>
</div>
</template>

<script>
import AdminNav from '@/components/AdminNav'
import CurrentUserNav from '@/components/CurrentUserNav'
import SupportNav from '@/components/SupportNav'

export default {
  computed: {
    admin () {
      return this.role === 'admin'
    },

    support () {
      return this.role === 'support_user'
    },

    currentUser () {
      let u = this.$parent.currentUser

      if (u.id) {
        return u
      }
    },

    role () {
      return this.$parent.currentUser.role_alias
    }
  },

  components: {
    'admin-nav': AdminNav,
    'current-user-nav': CurrentUserNav,
    'support-nav': SupportNav
  }
}
</script>

<style>
header {
  margin-left: 0px;
  margin-right: 0px;
  padding-left: 0px;
  padding-right: 0px;
}

.nav, .nav ul, .nav-link {
  padding-left: 0;
  padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderNav.vue